export const IMAGES = {
  LOGO: require("./logo.png"),
  LOGO_MOBILE: require("./logo-sm.png"),
  AUTH_BACKGROUND: require("./auth-back.jpg"),
};
